import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
  ModalSheetContentIllustration,
  ModalSheetContentBlock,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { ErrorBlock } from '@/components/ErrorBlock'
import styles from './CancelUserTransactionModal.module.css'
import { byDesign } from '@/infra/design'
import imgRemoveCollaboratorUrl from '@/assets/misc/img_remove-collaborator.svg'
import DocumentsDisabledIllustration from '@/components/SpotIllustration/DocumentsDisabledIllustration'

export interface CancelUserTransactionModalProps {
  showing: boolean
  onClose: () => unknown
  transactionShortId: string
  isCancelPending: boolean
  onCancelTransaction: () => unknown
  error?: unknown
}

export function CancelUserTransactionModal({
  showing,
  onClose,
  transactionShortId,
  isCancelPending,
  onCancelTransaction,
  error,
}: CancelUserTransactionModalProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isCancelPending ? undefined : onClose}
    >
      <>
        <ModalSheetHeader withCloseButton />
        <ModalSheetContent>
          <ModalSheetContentIllustration
            src={imgRemoveCollaboratorUrl}
            illustration={byDesign(undefined, DocumentsDisabledIllustration)}
          />
          <ModalSheetContentBlock>
            <ModalSheetContentTitle>
              You are about to cancel a transaction
            </ModalSheetContentTitle>
            <ModalSheetContentDescription>
              Are you sure you want to cancel transaction{' '}
              <span className={styles.transactionId}>{transactionShortId}</span>
              ? This action cannot be undone.
            </ModalSheetContentDescription>
          </ModalSheetContentBlock>
        </ModalSheetContent>
        {!!error && <ErrorBlock tackOn="bottom" error={error} />}
        <ModalSheetFooter>
          <ModalSheetFooterSpacer />
          <ModalSheetFooterButtonGroup>
            <Button
              label="Close"
              onPress={onClose}
              isDisabled={isCancelPending}
            />
            <Button
              label="Cancel Transaction"
              variant="destructive"
              isDisabled={isCancelPending}
              isPending={isCancelPending}
              onPress={onCancelTransaction}
            />
          </ModalSheetFooterButtonGroup>
        </ModalSheetFooter>
      </>
    </ModalSheet>
  )
}
